import { Alert } from '@material-ui/lab'
import React from 'react'

export default function NoDataFound({text="No Data Found"}) {
  return (
      <Alert variant="outlined" severity="info" className="w-full">{text}</Alert>
  )
}
